module.exports = __webpack_public_path__ + "img/sezione_assistenza_sanitaria.fc8ead43.jpg";